module.exports = __webpack_public_path__ + "img/logo-sm-light.c0446137.png";